// extracted by mini-css-extract-plugin
export default {"sku":"SDLrh4"};